import { getToken } from "firebase/messaging";
import { initFirebase } from "./firebase";
import { api } from "../api/api";

export const registerVendorNotification = async (vendorId) => {
    try {
        const permission = await Notification.requestPermission();

        if (permission !== "granted") {
            return;
        }

        // ✅ Destructure config from initFirebase
        const { messaging, vapidKey, config } = await initFirebase();
        if (!messaging || !vapidKey) throw new Error("Firebase failed to initialize properly");

        // ✅ Convert config to URL query string
        const queryParams = new URLSearchParams(config).toString();

        // ✅ Register SW with dynamic credentials in the URL
        const registration = await navigator.serviceWorker.register(
            `/firebase-messaging-sw.js?${queryParams}`
        );

        await navigator.serviceWorker.ready;

        // ✅ GET TOKEN
        const token = await getToken(messaging, {
            vapidKey: vapidKey,
            serviceWorkerRegistration: registration
        });

        // ✅ SAVE TOKEN
        await api.post(
            "/notifications/save-token", {
                user_id: vendorId,
                role: "VENDOR",
                token: token
            }
        );

    } catch (err) {
        console.log("VENDOR NOTIFICATION ERROR:", err);
    }
};